/* istanbul ignore file */
export default {
  date: {
    type: 'string',
    required: true,
  },
  description: {
    type: 'string',
    required: false,
  },
};
